import * as React from "react";

const ThumbsDownIcon = ({ filled = false, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_19365_33210)">
      {filled ? (
        // Filled version - solid black fill
        <>
          <path
            d="M8.79333 0.666687C8.5072 0.666687 8.2412 0.814107 8.08953 1.05677L5 6.00002V14H12.1759C12.681 14 13.1427 13.7147 13.3685 13.263L14.7185 10.5631C14.9036 10.1928 15 9.78449 15 9.37049V6.66669C15 5.93031 14.4031 5.33335 13.6667 5.33335H9.33333L10.0107 2.17249C10.1767 1.39749 9.58593 0.666687 8.79333 0.666687Z"
            fill="#334155"
          />
          <path
            d="M1.3335 6.66667C1.3335 6.29848 1.63198 6 2.00016 6H4.00016V14H2.00016C1.63198 14 1.3335 13.7015 1.3335 13.3333V6.66667Z"
            fill="#334155"
          />
        </>
      ) : (
        // Outline version - stroke only
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2364 2.67443L9.66665 5.33335H13.3333C14.4379 5.33335 15.3333 6.22879 15.3333 7.33335V9.37049C15.3333 9.78449 15.2369 10.1928 15.0518 10.5631L13.8861 12.8944C13.5473 13.572 12.8548 14 12.0972 14H2.66665C1.93027 14 1.33331 13.4031 1.33331 12.6667V7.33335C1.33331 6.59697 1.93027 6.00002 2.66665 6.00002H4.66665L7.67491 1.1868C7.87711 0.863247 8.23178 0.666687 8.61331 0.666687C9.67011 0.666687 10.4578 1.6411 10.2364 2.67443ZM4.66665 7.00002H2.66665C2.48255 7.00002 2.33331 7.14929 2.33331 7.33335V12.6667C2.33331 12.8508 2.48255 13 2.66665 13H4.66665V7.00002ZM12.9916 12.4472C12.8223 12.786 12.476 13 12.0972 13H5.66665V6.28682L8.52291 1.7168C8.54238 1.68563 8.57658 1.66669 8.61331 1.66669C9.03345 1.66669 9.34665 2.05408 9.25865 2.4649L8.68885 5.12383C8.62558 5.41911 8.69911 5.72718 8.88898 5.96203C9.07885 6.19688 9.36465 6.33335 9.66665 6.33335H13.3333C13.8856 6.33335 14.3333 6.78109 14.3333 7.33335V9.37049C14.3333 9.62922 14.273 9.88442 14.1574 10.1159L12.9916 12.4472Z"
          fill="#334155"
        />
      )}
    </g>
    <defs>
      <clipPath id="clip0_19365_33210">
        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(-180)" />
      </clipPath>
    </defs>
  </svg>
);

export default ThumbsDownIcon;
